export default __webpack_public_path__ + "static/card-5-d1847cdedecb8444a3bef9b64372b2dd.png";